export class OptionsFormatHelper {
    static _textOptionsFormats = {
        generationDate: {
            text: "Data de Geração",
            value: "{generation_date}"
        },
        lineCode: {
            text: "Código da Linha",
            value: "{line_code}"
        },
        lineName: {
            text: "Nome da Linha",
            value: "{line_name}"
        },
        stopCode: {
            text: "Código da Paragem",
            value: "{stop_code}"
        },
        stopName: {
            text: "Nome da Paragem",
            value: "{stop_name}"
        },
        schedules: {
            text: "Nome(s) do(s) Horário(s)",
            value: "{schedules}"
        }
    }

    static getOptionText(option) {
        if(undefined === this._textOptionsFormats[option]) {
            return "";
        }

        return this._textOptionsFormats[option].text;
    }

    static getOptionValue(option) {
        if(undefined === this._textOptionsFormats[option]) {
            return "";
        }

        return this._textOptionsFormats[option].value;
    }

    static getOptionTextFromValue(value) {
        let i = 0;
        for(i in this._textOptionsFormats) {
            if(this._textOptionsFormats[i].value === value) {
                return this._textOptionsFormats[i].text;
            }
        }

        return "";
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/helpers/OptionsFormatHelper.js